import React from "react";

function Footer() {
  const year = new Date();

  return (
    <div className="footer">
      <div className="footer-content">
        <div className="footer-item">
          <div>
            &copy;{" "}
            <a href="http://www.greghamel.com">
              Greg Hamel, 2018 - {year.getUTCFullYear()}
            </a>
          </div>
        </div>
        <div className="footer-item">
          <div>
            <a href="mailto:admin@weatheredstrip.com?subject=Weathered Strip Issue">
              Report an Issue
            </a>
          </div>
        </div>
        <div className="footer-item">
          Made in{" "}
          <span role="img" aria-label="Canada">
            🍁
          </span>{" "}
          with{" "}
          <span role="img" aria-label="love">
            ❤️
          </span>
        </div>
      </div>
    </div>
  );
}

export default Footer;
